export class GSTR1Report{
    ReportType : string;
    ToleranceByTaxableAmt:number;
    ToleranceByTaxAmt:number;
  }